/**
 * Helper to explicitly continue navigation.
 * - Always returns undefined (Vue Router interprets this as "go ahead").
 * - Makes guard usage clearer and avoids passing values like false/null by mistake.
 */
export const go = () => {
  return undefined;
};

export const hasAnyRole = (roles, allowed) => {
  return roles.some((role) => allowed.includes(role.name));
};

export const hasAnyPermission = (storepermissions, permissions) => {
  return storepermissions.some((permission) =>
    permissions.includes(permission.name)
  );
};
